// extracted by mini-css-extract-plugin
module.exports = {"recuar":"PoliticaDePrivacidade_recuar__o3j8E"};